import InvoiceConfiguration from './InvoiceConfiguration';
import OpeningBalance from './OpeningBalance';
import ReserveRateCRU from './ReserveRateCRU';
import ReserveRateList from './ReserveRateList';
import ReserveStatusChange from './ReserveStatusChange';

export { ReserveRateList, ReserveRateCRU,ReserveStatusChange,InvoiceConfiguration, OpeningBalance};

export const reserveRateObj = {
  name: null,
  account_type: null,
  rate_start_date: null,
  rate_end_date: null,
  reserve_rate_type: null,
  interval: null,
  reserve_rate_per_interval: null,
  starting_fund_date: null,
  // starting_fund_amount: null,
  thrusts: null,
  rate_escalation_percentage: "",
  // cost_escalation_percentage: null,
  rate_escalation_interval: null,
  rate_escalation_start_date: null,
  is_notional_mr: false,
  status: true,
  region_based_esc: false,
  max_cap_applicable: false,
  is_additional_amount: false,
  max_cap_amount: null,
  additional_amount: null,
  round_off_escalation: null,
  interval_condition: [],
  adjustment_factor: [{
    ratio: "0",
    adjustment_factor: "0",
    id:`adjustment_factor_0`
  },],
  pbh_condition: [],
  pbh_range_type: false,
  is_pbh_fixed_table: false,
  fixed_rate: false,
  base_reading_escaltaion: false,
  fixed_table_condition: {
    fixed: null,
    fc_rate: null,
    fh_rate: null,
  },
  is_prorated :true,
  engine_split_details:[],
  claim_type: {value : 1,label :"PRSV"},
  claim_event_type: {value : 1 ,label :"Fund"}
}


export const muicpRateObj = {
  year: null,
  to_record_period: null,
  from_record_period: null,
  annual_inflation: null,
}

export const labelMap = {
  2: "FOR FH",
  3: "FOR FC",
  4: "FOR FH",
  6: "FOR BH",
  8: "Ratio Table",
  9: "Ratio Table",
  10: "DeRate Table",
  11: "Ratio/DeRate Table",
};

export const InvoiceDays = [1,2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30];    

export const getDayLabel = (value) => {
  const day = parseInt(value, 10);
  if (isNaN(day)) return "";
  const suffix =
    day % 10 === 1 && day % 100 !== 11
      ? "st"
      : day % 10 === 2 && day % 100 !== 12
      ? "nd"
      : day % 10 === 3 && day % 100 !== 13
      ? "rd"
      : "th";
  return `${day}${suffix} of Month`;
};

export const openingBalanceObj = {
  opening_balance_engine_split_details:[],
  claim_type: {value : 1,label :"PRSV"},
  claim_event_type: {value : 1 ,label :"Fund"}
}

export const eolAdjArr= [
  {
      label: 'Maintenance Reserve Payment Obligation',
      value: 0,
      key: 'maintenance_reserve_payment_obligation'
  },
  {
      label: 'Lessor Contribution',
      value: 0,
      key: 'lessor_contribution'
  },
  {
      label: 'MR Payment Obligation Waived',
      value: 0,
      key: 'mr_payment_obligation_waived'
  },
  {
      label: 'MR Abatement Allowed',
      value: 0,
      key: 'mr_abatement_allowed'
  },
  {
      label: 'Refund at Event',
      value: 0,
      key: 'refund_at_event'
  },
  {
      label: 'End of Lease Obligation',
      value: 0,
      key: 'end_of_lease_obligation'
  },
  {
      label: 'End of Lease Obligation Rates in Contract',
      value: 0,
      key: 'end_of_lease_obligation_rates_in_contract'
  },
  {
      label: 'Required Maintenance Rent Balance at the Termination Date',
      value: 0,
      key: 'required_maintenance_rent_balance_at_termination_date'
  },
  {
      label: 'Dual Rate Applies',
      value: 0,
      key: 'dual_rate_applies'
  },
  {
      label: 'LLP is Baseline',
      value: 0,
      key: 'llp_is_baseline'
  },
  {
      label: 'Full LLP Disbursement',
      value: 0,
      key: 'full_llp_payout'
  },
]